import { render, staticRenderFns } from "./ModalRole.vue?vue&type=template&id=4d7840be&scoped=true&"
import script from "./ModalRole.vue?vue&type=script&lang=js&"
export * from "./ModalRole.vue?vue&type=script&lang=js&"
import style0 from "./ModalRole.vue?vue&type=style&index=0&id=4d7840be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7840be",
  null
  
)

export default component.exports